/*
* @Author: 王春岩 <Bolt>
* @Date:   2016-12-21 16:30:47
* @Last Modified by:   Bolt
* @Last Modified time: 2016-12-21 16:31:27
*/

'use strict';



// WEBPACK FOOTER //
// ./src/modules/header.empty/index.js